import * as types from './mutation-types'

export default {
  [types.LOAD_STATISTICS](state, data) {
    state.statistics = data
  }
}

